function formatDate(vfecha) {
  //return(vfecha);

  //console.log('-fecha-' + vfecha + '--')
  if (vfecha == null) {
    return ('')
  }
  else {
    let vnfecha = vfecha.substr(0, 10);
    return (vnfecha.substr(5, 2) + '/' + vnfecha.substr(8, 2) + '/' + vnfecha.substr(0, 4));
  }
}

function formatDNI(eldni) {

  //validacion que agregué para q no se rompa 
  if (!eldni) return "";

  eldni = eldni.toString();

  var formattedDNI = '';
  // Añadir puntos cada tres dígitos desde el final
  for (let i = eldni.length - 1, j = 0; i >= 0; i--, j++) {
    if (j > 0 && j % 3 === 0) {
      formattedDNI = '.' + formattedDNI;
    }
    formattedDNI = eldni[i] + formattedDNI;
  }
  return (formattedDNI);
}

function formatCurrency(importe) {
  const opcMoneda = {
    style: 'currency',
    currency: 'ARS', // Código ISO de la moneda
    minimumFractionDigits: 2, // Mínimo de decimales
    useGrouping: 'always',
    currencyDisplay: 'narrowSymbol' // 'symbol', 'narrowSymbol', 'code', 'name'
  };
  const formatter = new Intl.NumberFormat('es-ES', opcMoneda);
  return (formatter.format(importe));
}
function monthDiff(date2, date1) {
  var dife = 0;
  let months = (new Date(date2).getFullYear() - new Date(date1).getFullYear()) * 12;
  months += new Date(date2).getMonth() - new Date(date1).getMonth();
  if (months > 0) {
    dife = months

  }

  return dife;
}
export { formatDate, formatDNI, formatCurrency, monthDiff }